import { Loader2 } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useI18n } from "@/lib/i18n";

export default function SignedInCtaDialog({
  open,
  onOpenChange,
  title,
  description,
  primaryAction,
  accountAction = null,
  onPrimaryAction,
  onAccountAction,
  onLogoutAndContinue,
  onCancel,
  loading = false,
  logoutLoading = false,
}) {
  const { tx } = useI18n();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm rounded-3xl p-0" data-testid="landing-signed-in-dialog">
        <div className="space-y-6 p-6">
          <DialogHeader className="space-y-2 text-left">
            <DialogTitle className="font-display text-2xl font-bold tracking-tight">{tx(title)}</DialogTitle>
            <DialogDescription className="text-sm leading-relaxed text-muted-foreground">
              {tx(description)}
            </DialogDescription>
          </DialogHeader>

          {loading ? (
            <div className="flex items-center gap-3 rounded-2xl border bg-card px-4 py-4 text-sm text-muted-foreground">
              <Loader2 className="h-4 w-4 animate-spin" />
              {tx("Checking this account...")}
            </div>
          ) : (
            <div className="space-y-3">
              <Button
                type="button"
                className="h-12 w-full rounded-2xl"
                onClick={onPrimaryAction}
                data-testid="landing-signed-in-primary-action"
              >
                {tx(primaryAction?.label || "Continue")}
              </Button>

              {accountAction ? (
                <Button
                  type="button"
                  variant="outline"
                  className="h-12 w-full rounded-2xl"
                  onClick={onAccountAction}
                  data-testid="landing-signed-in-account-action"
                >
                  {tx(accountAction.label)}
                </Button>
              ) : null}

              <Button
                type="button"
                variant="outline"
                className="h-12 w-full rounded-2xl"
                onClick={onLogoutAndContinue}
                disabled={logoutLoading}
                data-testid="landing-signed-in-logout-action"
              >
                {logoutLoading ? (
                  <>
                    <Loader2 className="h-4 w-4 animate-spin" />
                    {tx("Logging out...")}
                  </>
                ) : (
                  tx("Log out and continue")
                )}
              </Button>

              <Button
                type="button"
                variant="ghost"
                className="h-11 w-full rounded-2xl"
                onClick={onCancel}
              >
                {tx("Cancel")}
              </Button>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
